import { render, staticRenderFns } from "./QuotazioneDrawer.vue?vue&type=template&id=45d6ca78&scoped=true"
import script from "./QuotazioneDrawer.vue?vue&type=script&lang=js"
export * from "./QuotazioneDrawer.vue?vue&type=script&lang=js"
import style0 from "./QuotazioneDrawer.vue?vue&type=style&index=0&id=45d6ca78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6ca78",
  null
  
)

export default component.exports